// extracted by mini-css-extract-plugin
export default {"DimensionsFeature":"wq_a big_b big_we"};